import { FragmentState } from '../interfaces';
import { Trace } from '../../../metrics';
class FullScreenTargetStateLatencyBuilder {
    constructor(targetState) {
        this.targetState = targetState;
        this.initialize = (startTime, tenantId) => {
            this.latencyTrace = Trace(`FullScreen${FragmentState[this.targetState]}Latency`, tenantId, { startTime });
            this.traceTimeoutId = setTimeout(this.emitTrace, FullScreenTargetStateLatencyBuilder.LATENCY_TIMEOUT);
        };
        this.terminate = () => {
            this.clearTimeout();
        };
        this.stateChanged = (newState) => {
            const { fragmentStateMap } = newState;
            if (this.reachTargetState(fragmentStateMap)) {
                this.emitTrace();
            }
        };
        this.reachTargetState = (fragmentStateMap) => ([...fragmentStateMap.values()].find((value) => (value < this.targetState)) === undefined);
        this.emitTrace = () => {
            var _a;
            (_a = this.latencyTrace) === null || _a === void 0 ? void 0 : _a.log();
            this.clearTimeout();
        };
        this.clearTimeout = () => {
            if (this.traceTimeoutId) {
                clearTimeout(this.traceTimeoutId);
                this.traceTimeoutId = undefined;
            }
        };
    }
}
FullScreenTargetStateLatencyBuilder.LATENCY_TIMEOUT = 30 * 1000;
export default FullScreenTargetStateLatencyBuilder;
//# sourceMappingURL=FullScreenTargetStateLatencyBuilder.js.map